export function initCampaigns() {
  const wrapper = document.getElementById("bpa-campaign-wrapper");
  if (!wrapper) return;

  const dismissedKey = wrapper.dataset.dismissedKey;
  const appearanceType = wrapper.dataset.appearanceType;
  const popUpTiming = parseInt(wrapper.dataset.popUpTiming || "0", 10);

  /* ── 1. Already dismissed in this tab session? Exit ── */
  if (sessionStorage.getItem(dismissedKey)) return;

  /* ── 2. Dismiss handler ── */
  function dismissCampaign() {
    sessionStorage.setItem(dismissedKey, "true");
    hideCampaign();
  }

  function hideCampaign() {
    wrapper.classList.add("bpa-campaign--hiding");

    const fallback = setTimeout(() => {
      wrapper.classList.add("bpa-campaign--init");
      wrapper.classList.remove("bpa-campaign--hiding", "bpa-campaign--visible");
    }, 400);

    wrapper.addEventListener("animationend", function onEnd() {
      clearTimeout(fallback);
      wrapper.classList.add("bpa-campaign--init");
      wrapper.classList.remove("bpa-campaign--hiding", "bpa-campaign--visible");
      wrapper.removeEventListener("animationend", onEnd);
    });
  }

  function showCampaign() {
    wrapper.classList.remove("bpa-campaign--init");
    wrapper.classList.add("bpa-campaign--visible");

    wrapper.querySelectorAll("[data-campaign-close]").forEach((btn) => {
      btn.addEventListener("click", dismissCampaign);
    });
  }

  if (appearanceType === "Announcement") {
    showCampaign();
  } else {
    setTimeout(showCampaign, popUpTiming * 1000);
  }
}
